import { logDebug } from "helpers/generic";
import React, { ReactNode } from "react";
import globalDictionary from "configs/dictionary";

interface Dictionary {
  [key: string]: React.FC<any>;
}

interface CfElement {
  __typename?: string;
  content?: any;
  [key: string]: any;
}

type RecursiveRenderProps = {
  cfComponent: CfElement | CfElement[];
  dictionary?: Dictionary;
  debug?: boolean;
};

const recursiveRender = ({
  cfComponent,
  dictionary = globalDictionary,
}: RecursiveRenderProps) => {
  const renderElement = (
    element: CfElement | CfElement[],
  ): ReactNode | ReactNode[] => {
    const randomKey = Math.random().toString();
    let renderedHTML: ReactNode | ReactNode[] = null;

    if (Array.isArray(element)) {
      renderedHTML = element.map(renderElement);
    } else if ((element?.__typename ?? "") !== "") {
      const { __typename } = element;
      const { content, ...props } = element || {};

      logDebug("[0] render element ->", element);
      const Component = dictionary?.[`${__typename}`];

      if (!Component) {
        logDebug("ERROR: component not found: ", __typename);
      }

      logDebug("[1] Component exist ->", Component);

      renderedHTML = content ? (
        <Component {...props} key={randomKey}>
          {renderElement(content)}
        </Component>
      ) : (
        <Component {...props} key={randomKey} />
      );
    }

    return renderedHTML;
  };

  return renderElement(cfComponent);
};

export default recursiveRender;
